export default __webpack_public_path__ + "static/media/fr-asia-13.68952a61.jpg";